import React from 'react';
import S from '@/styles/reactImgsBallast.module.css';

const InfoB = ({ top, left, B }) => {
  return (
    <>
      {Number(B[1]) > 0 ? (
        <div className={S.value} style={{ top: top, left: left, width: 'auto' }}>
          {B}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default InfoB;
